import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-16 md:py-20">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="relative bg-background-900 rounded-2xl overflow-hidden p-10 md:p-14 text-center">
          <div className="absolute inset-0 opacity-15">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20abstract%20background%20with%20soft%20golden%20and%20amber%20gradient%20light%20streaks%2C%20elegant%20bokeh%20effect%2C%20cozy%20movie%20night%20atmosphere%2C%20dark%20rich%20tones%2C%20cinematic%20feel%2C%20high%20quality%20abstract%20texture&width=1200&height=500&seq=cta-bg-popcorn&orientation=landscape"
              alt=""
              className="w-full h-full object-cover"
            />
          </div>

          <div className="relative z-10">
            <span className="inline-block px-3 py-1 rounded-full bg-background-50/15 text-background-200 text-xs font-medium mb-6">
              开始探索
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-4">
              准备好畅享高清观影体验了吗？
            </h2>
            <p className="text-sm md:text-base text-background-300 max-w-lg mx-auto mb-8 leading-relaxed">
              我们已为您精心筛选了最优质的看片网站，无需注册、全部免费，立即开始您的观影之旅！
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="/category/movie"
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 font-semibold rounded-lg hover:bg-primary-600 transition-all duration-200 text-sm whitespace-nowrap"
              >
                浏览电影网站 <i className="ri-arrow-right-line ml-2"></i>
              </Link>
              <Link
                to="/about"
                className="w-full sm:w-auto px-8 py-3.5 bg-background-50/15 text-background-50 font-medium rounded-lg border border-background-50/25 hover:bg-background-50/25 transition-all duration-200 text-sm whitespace-nowrap"
              >
                了解更多 <i className="ri-information-line ml-2"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}